import { dailyTimeline, hotSpots } from "@/mocks/news";

export default function HotSpots() {
  return (
    <section id="live" className="relative scroll-mt-20 overflow-hidden bg-foreground-950">
      {/* 装饰网格 */}
      <div className="dotted-rule pointer-events-none absolute inset-0 opacity-[0.12]" />

      <div className="relative mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-widest text-accent-400">
              <i className="ri-camera-lens-line" /> ON THE SCENE
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-background-50 md:text-3xl">
              现场直击 · 焦点追踪
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-6 text-background-200/80">
              不追一手的转述，我们还原一手现场。多信源交叉，逐条拆解今日最热进展。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-accent-400/40 bg-accent-400/10 px-3 py-1.5 text-xs font-semibold text-accent-300">
            <i className="ri-live-line" /> 焦点持续更新中
          </span>
        </div>

        {/* 焦点大卡 */}
        <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {hotSpots.map((h, idx) => (
            <article
              key={h.id}
              className={
                "group relative overflow-hidden rounded-xl border border-background-200/15 " +
                (idx === 0 ? "md:col-span-2 md:row-span-2" : "")
              }
            >
              <div className="relative w-full overflow-hidden" style={{ height: idx === 0 ? "100%" : "230px", minHeight: "230px" }}>
                <img
                  src={h.image}
                  alt={h.title}
                  className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/20 to-transparent" />
                <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-[11px] font-bold text-background-50">
                  <i className="ri-map-pin-2-line" /> {h.place}
                </span>
              </div>

              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                <p className="flex items-center gap-3 text-[11px] text-background-200/80">
                  <span className="inline-flex items-center gap-1"><i className="ri-eye-line" />{h.reads}</span>
                  <span className="inline-flex items-center gap-1"><i className="ri-thumb-up-line" />{h.up}</span>
                </p>
                <h3 className={"mt-1.5 font-heading font-bold leading-snug text-background-50 " + (idx === 0 ? "text-xl md:text-2xl" : "text-base")}>
                  {h.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-5 text-background-200/85">
                  {h.summary}
                </p>
                <span className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-accent-300">
                  查看完整拆解 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </article>
          ))}
        </div>

        {/* 事件时间线 */}
        <div className="mt-12 grid gap-8 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-1.5 rounded-md bg-accent-100 px-2.5 py-1 text-[11px] font-bold text-accent-800">
              <i className="ri-timer-flash-line" /> 今日焦点时间线
            </span>
            <h3 className="mt-3 font-heading text-xl font-black leading-snug text-background-50 md:text-2xl">
              周景川声明事件，<br className="hidden sm:block" />
              12 小时内的完整轨迹
            </h3>
            <p className="mt-3 max-w-md text-sm leading-6 text-background-200/80">
              从深夜声明到午后当事人发声，我们按时间节点把每个关键转折都摆到明面上，
              帮助你在信息过载里快速抓主线。
            </p>
          </div>
          <div className="lg:col-span-7">
            <ol className="relative ml-2 space-y-0 border-l-2 border-accent-400/40 pl-6">
              {dailyTimeline.map((t) => (
                <li key={t.time} className="relative pb-7 last:pb-0">
                  <span className="absolute -left-[31px] flex h-5 w-5 items-center justify-center rounded-full border-4 border-foreground-950 bg-accent-400" />
                  <p className="font-heading text-sm font-bold text-accent-300">{t.time}</p>
                  <h4 className="mt-1 text-sm font-bold text-background-50 md:text-base">{t.title}</h4>
                  <p className="mt-1 text-xs leading-5 text-background-200/70">{t.desc}</p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}